import {
  ProjectManagementProjectDetailsPageSettingsBudgetSectionUpdateBudgetDocument,
  ProjectManagementProjectDetailsPageSettingsBudgetSectionUpdateBudgetMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

interface updateFixedTimeBudgetDto {
  id: number
  budgetAllocation: number
}

export const useUpdateFixedTimeBudget = () => {
  const [updateFixedTimeBudget] = useMutation(
    ProjectManagementProjectDetailsPageSettingsBudgetSectionUpdateBudgetDocument,
    {
      extractorFn: (
        data: ProjectManagementProjectDetailsPageSettingsBudgetSectionUpdateBudgetMutation
      ) => data.projectManagementMutations.updateProjectmanagementFixedTimeBudget,
    }
  )

  return {
    update(dto: updateFixedTimeBudgetDto) {
      const { id, budgetAllocation } = dto

      return updateFixedTimeBudget({
        variables: {
          id,
          budgetAllocation,
        },
        optimisticResponse: {
          projectManagementMutations: {
            updateProjectmanagementFixedTimeBudget: {
              errors: [],
              fixedTimeBudget: {
                __typename: 'ProjectManagementFixedTimeBudget',
                id: id,
                budgetAllocation: budgetAllocation,
              },
            },
          },
        },
      })
    },
  }
}
